export default __webpack_public_path__ + "static/media/photo--sm--group-2.57d6e5c2.jpg";